import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

export const options = {
  responsive: true,
  aspectRatio: 2,
  layout: {
    padding: {
      right: 0,
    },
  },
  plugins: {
    tooltip: false,
    legend: {
      position: "right",
      align: "end",
      labels: {
        usePointStyle: true,
        padding: 20,
      },
    }
  },
  elements: {
    point: {
      pointRadius: 3,
    },
  },
  scales: {
    x: {
      min: 0,
      suggestMax: 20,
      ticks: { display: false, stepSize: 5, },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },
    y: {
      min: -100,
      max: 200,
      ticks: { display: true, stepSize: 50, },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },


  }
};

const pluginRanges = {
  id: 'ranges',
  beforeDraw(chart, args, options) {
    const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;
    const midX = x.getPixelForValue(0);
    const y8 = y.getPixelForValue(8);
    const y32 = y.getPixelForValue(32);
    const y156 = y.getPixelForValue(153);
    const y200 = y.getPixelForValue(200);

    ctx.save();
    ctx.fillStyle = "#e4f1ff";
    ctx.fillRect(left, y200, right - left, y156 - y200);


    ctx.fillStyle = "#fee9e9";
    ctx.fillRect(midX, y32, right - left, y8 - y32);

    ctx.restore();
  }
};

var pitchData = {
  velo: [{ x: 1, y: 130 }, { x: 2, y: 130 }, { x: 3, y: 100 }, { x: 4, y: 110 }],//null 跳過
  angle: [{ x: 1, y: 45 }, { x: 2, y: -30 }, { x: 3, y: 10 }, { x: 4, y: 20 }],//null 跳過
};

// const data = {
//   datasets: [
//     {   //velo   
//         label:"E_Velo",                                  
//         pointBackgroundColor:"#0080FF",    
//         borderWidth:1,
//         borderColor:"#000000",         
//         data: pitchData.velo,

//     },
//     {   //angle   
//         label:"E_Angle",                    
//         pointBackgroundColor:"#ff0000",    
//         borderWidth:1,
//         borderColor:"#000000",         
//         data: pitchData.angle,

//     }
//   ],
// };

export function HitAngleChart({ velo = [], angle = [] }) {
  const b = { x: -1, y: 0 }
  const [data, setData] = useState({
    datasets: [
      {   //velo   
        label: "E_Velo",
        pointBackgroundColor: "#0080FF",
        borderWidth: 1,
        borderColor: "#000000",
        data: velo,

      },
      {   //angle   
        label: "E_Angle",
        pointBackgroundColor: "#ff0000",
        borderWidth: 1,
        borderColor: "#000000",
        data: angle,

      }
    ],
  })


  useEffect(() => {
    var v = []
    v = JSON.parse(JSON.stringify(velo))
    v.unshift(b)
    
    
    //console.log(v)
    setData({
      datasets: [
        {   //velo   
          label: "E_Velo",
          pointBackgroundColor: "#0080FF",
          borderWidth: 1,
          borderColor: "#000000",
          data: velo,

        },
        {   //angle   
          label: "E_Angle",
          pointBackgroundColor: "#ff0000",
          borderWidth: 1,
          borderColor: "#000000",
          data: angle,

        }
      ],
    })
  }, [velo, angle])





  return <Bubble options={options} plugins={[pluginRanges]} data={data} />;
}
